import { createSelector } from "reselect";

export function createWoundSeriesQuerySelector() {
  return createSelector(() => {
    return "?page%5Blimit%5D=1000";
  });
}
